


























































import RadioGroupModal from "@/components/Molecules/RadioGroupModal/index.vue";
import FixedButtonRow from "@/components/Atoms/FixedButtonRow/index.vue";
import CoverageAnalysesItem from "@/components/Molecules/CoverageAnalysesItem/index.vue";
import CoverageAnalysesResult from "@/components/Molecules/CoverageAnalysesResult/index.vue";
import { defineComponent, ref } from "vue";
import { mapState, mapActions, mapMutations } from "vuex";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import { Simulation } from "@/api/coverageAnalysis";

export default defineComponent({
  components: {
    RadioGroupModal,
    FixedButtonRow,
    CoverageAnalysesItem,
    CoverageAnalysesResult
  },
  setup() {
    const showSortModal = ref(false);
    const activeSort = ref("");
    return {
      showSortModal,
      activeSort
    };
  },
  async mounted() {
    this.$root.$emit("show-loading");
    await this.validateLimit();

    const result = await this.fetchSimulations();
    if (!result) {
      Swal.fire({
        icon: "error",
        text: "Não foi possível carregar a lista de exames",
        confirmButtonText: "OK"
      });
    }
    this.SET_SEARCH_EXAMS([]);
    this.SET_SELECTED_EXAMS([]);
    this.SET_SEARCH_LABS([]);

    this.$root.$emit("hide-loading");
  },
  computed: {
    ...mapState("auths", ["newAuthSuccess"]),
    ...mapState("coverageAnalysis", ["authorized", "simulations", "searchExams"]),
    authorizedState(): boolean {
      return this.authorized;
    },
    items(): Simulation[] {
      return this.simulations;
    }
  },
  methods: {
    ...mapActions("coverageAnalysis", ["validateLimit", "fetchSimulations"]),
    ...mapMutations("coverageAnalysis", ["SET_SEARCH_EXAMS", "SET_SELECTED_EXAMS", "SET_SEARCH_LABS"]),
    handleClick() {
      this.$router.push({
        name: "analise_cobertura.nova_analise"
      });
    }
  }
});
